import { type Provider, inject } from '@angular/core';

import { API_TRANSPORT } from '@common/api';
import { CMS_SITE_ADDRESS, CMS_TRANSPORT, type ISiteAddress } from '@rt-tools/cms-angular';
import { SitePagesApiService } from '@rt-tools/cms-angular/site';
import { SITE_ORIGIN } from '@stair-craft/common/util';

import { BlogArticlesApiService } from './blog-articles-api.service';

// Клиент страниц CMS ходит к серверу тем же транспортом, что и весь сайт: на сервере сайта это
// адрес сервера, в браузере — путь своего домена. Страницы без своей ссылки живут в блоге.
//
// Провайдеры отдаются экранам, читающим статьи, а не приложению: главный вход пакета CMS везёт
// очистку разметки, и в конфигурации приложения он лёг бы в начальный бандл сайта. Клиенты пакета и
// блога объявлены здесь же — объявленные в корне, они искали бы токены в корне и падали на внедрении.
export function provideBlogCms(): Provider[] {
    return [
        { provide: CMS_TRANSPORT, useExisting: API_TRANSPORT },
        {
            provide: CMS_SITE_ADDRESS,
            useFactory: (): ISiteAddress => ({ baseUrl: inject(SITE_ORIGIN), sectionRoot: '/blog' }),
        },
        SitePagesApiService,
        BlogArticlesApiService,
    ];
}
